<template>
  <section class="section">
    <div class="container">
      <h4
        class="title is-4 is-size-5-mobile has-text-secondary"
        v-t="'Collection.home_title'"
      ></h4>
      <p
        class="subtitle is-size-5 has-text-weight-light has-text-grey"
        v-t="'Collection.home_subtitle'"
      ></p>
      <div
        class="columns is-mobile is-centered is-scrollable is-variable is-0-desktop"
      >
        <div
          v-for="collection in collections"
          :key="collection._id"
          class="column is-two-thirds-mobile is-4-tablet is-3-desktop"
        >
          <router-link
            :to="{
              name: 'collection',
              params: { collectionId: collection._id }
            }"
          >
            <collection-bubble
              :collection="collection"
              class="has-text-primary"
            />
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { languageManager } from '@/mixins/LanguageManager'
import CollectionBubble from '@/components/CollectionBubble'
export default {
  mixins: [languageManager],
  components: { CollectionBubble },
  mounted () {
    this.$store.dispatch('fetchCollections')
  },
  computed: {
    collections () {
      return this.$store.state.collections.map(collection => {
        return this.transformObject(collection)
      })
    }
  }
}
</script>

<style scoped>
@media screen and (max-width: 768px) {
  .is-centered {
    justify-content: left !important;
  }

  .section .container .columns
     {
       margin-left: -1.5rem;
        margin-right: -1.5rem;
    }
}
</style>
